import React, { useContext } from 'react';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { styled, useTheme, forBrands } from '@core-ui/react-stitch';

const CatPageTitleText = ({ children }) => {
    const theme = useTheme();
    const { enabledFeatures } = useContext(FeatureFlagsContext);
    const brTertiaryFontsEnabled = enabledFeatures['br-tertiary-font'];

    const brandStyles = forBrands(theme, {
        gap: () => ({
            ...theme.font.primary,
            color: theme.color.g2,
            fontWeight: 700,
        }),
        gapfs: () => ({
            ...theme.font.primary,
            color: theme.color.g2,
            fontWeight: 700,
        }),
        br: () => ({
            ...(brTertiaryFontsEnabled ? ({
                    ...theme.font.tertiary,
                    fontSize: '2rem',
                    fontWeight: 400,
                    letterSpacing: '-0.02em',
                }) : ({
                    ...theme.font.primary,
                    fontWeight: 700,
                    letterSpacing: '0.15em',
                })
            ),
            color: theme.color.g1,
        }),
        brfs: () => ({
            ...theme.font.primary,
            fontWeight: 700,
            letterSpacing: '0.15em',
            color: theme.color.g1,
        }),
        at: () => ({
            ...theme.font.primary,
            color: theme.color.gray54,
            fontSize: `2.25rem`,
            letterSpace: 2,
        }),
        on: () => ({
            ...theme.font.primary,
            color: theme.color.g2,
            fontSize: '1.5rem',
            fontWeight: 400,
            letterSpacing: '0.10em',
        }),
    });

    const Header = styled.h1(() => ({
        display: 'inline',
        lineHeight: 1,
        fontSize: `1.6875em`,
        ...brandStyles,
    }));
    return <Header>{children}</Header>
}

export const FallbackHeader = ({
    position,
    shouldHideTitle,
    categoryName,
}) => {
    if (
      shouldHideTitle ||
      position === 'topPrimary' ||
      position === 'bottom') {
      return null;
    }

    return (
      <div className="cat-page-title limit-width clearfix">
        <CatPageTitleText>{categoryName}</CatPageTitleText>
      </div>
    );
  };

export default { FallbackHeader };
